import { Box } from '@mui/material'
import React from 'react'
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import styles from "../../styles/components/tablestyle.module.scss"

function TableSection(props) {
   
  return (
    <Box className={styles.tableWrapper}>
        <TableContainer >
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
       {props.children}
      </Table>
    </TableContainer>
    </Box>
  )
}

export default TableSection